<template>
  <tender-form-label :key="index" :label="options.Name" :prop="options.Key" :rules="rules">
    <bear-select
      :key="time"
      v-model="form[options.Key]"
      :attrs="attrs"
      :options="options"
      :disabled="options.Disabled"
      @change="selectChangeHandle"></bear-select>
  </tender-form-label>
</template>
<script>
import BearSelect from "~@/select/src";
import { mixForFormItem } from "../../../js/mixins";
import utils from "../../../js/utils";
import tenderHook from "../../../js/hooks";
import { mapState, mapGetters, mapActions, mapMutations } from "vuex";
export default {
  name: "FormSelectGclqd",
  mixins: [mixForFormItem],
  components: { BearSelect },
  data() {
    return {
      time: new Date().getTime(),
      fileLimitLength: 800,
    };
  },
  created() {
    this.init();
  },
  methods: {
    ...mapMutations(["setGclqdOptions"]),
    init() {
      let { value, param, form = {}, options = {} } = this;
      this.$nextTick(() => {
        this.setGclqdOptions(form.PROJECT_PRICE_LIST);
      });
    },

    selectChangeHandle(value) {
      let { form = {}, options = {}, properties } = this;
      let { Key, Refs = [], Options = [] } = options;
      let tableKey = Key.replace("_SELECT", "");

      if (!value || value === "无") {
        this.form[tableKey] = "";
        return false;
      }
      let project_price_list = form["PROJECT_PRICE_LIST"];
      if (project_price_list) {
        //判断条数是否超过800条，若超过进行提示
        let msg = "";
        project_price_list.forEach((item, index) => {
          if (item.name === value) {
            if (project_price_list[index].list.length >= this.fileLimitLength) {
              msg = "工程量清单过长，请咨询客服QQ：4008705191";
            }
          }
        });
        if (msg) {
          this.form[Key] = "";
          this.time = new Date().getTime();
          this.$alert(msg, "友情提示");
          return false;
        }

        project_price_list.forEach((item, index) => {
          if (item.name === value) {
            // this.$set(this.form, tableKey, this.dataHandle(tableKey, project_price_list[index].list));
            this.form[tableKey] = this.dataHandle(tableKey, project_price_list[index].list);
          }
        });
      }

      this.doValidate();
    },
    dataHandle(key, list) {
      let { form = {}, options = {} } = this;
      let { theadConfig } = options;
      let result = [];
      list.forEach((item) => {
        let obj = {};
        for (let name in theadConfig) {
          obj[name] = (item[theadConfig[name]] || "").trim();
        }
        result.push(obj);
      });
      return result;
    },
  },
};
</script>
<style>
</style>